<script lang="ts">
    import SvgCheck from "../icon/SvgCheck.svelte";
    import SvgEmpty from "../icon/SvgEmpty.svelte";

    export let require_images : {[key: string]: boolean};
</script>

<ul>
    {#each Object.keys(require_images) as textureid}
        <li>
            {#if require_images[textureid] === true}
                <SvgCheck />
            {:else}
                <SvgEmpty />
            {/if}
            {textureid}
        </li>
    {/each}
</ul>

<style>
    ul {
        list-style: none;
    }
    ul li {
        line-height: 40px;
        vertical-align: middle;
    }
</style>